import HelpLinksList from '@/pages/setup/link_handlers/help_links/components/HelpLinksList.tsx'
import { useHelpLinks } from '@/queries/help_links/hooks.ts'
import MultiQueryPageLoader from '@/common/components/MultiQueryPageLoader.tsx'
import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store.ts'

const HelpLinksPage = () => {
  const { selectedProgramYear } = useSelector((s: RootState) => s.programs)

  const { query: helpLinksQuery, invalidateQuery: invalidateHelpLinks } =
    useHelpLinks({ globalOnId: 1, program_id: selectedProgramYear?.id ?? 0 })

  const handleHelpLinkChange = () => invalidateHelpLinks()

  return (
    <MultiQueryPageLoader
      showLoadingOnlyOnFirstFetch={true}
      queries={[helpLinksQuery] as const}
    >
      {([helpLinks]) => {
        return (
          <HelpLinksList
            invalidateHelpLinks={invalidateHelpLinks}
            helpLinks={helpLinks.data}
            onHelpLinkChange={handleHelpLinkChange}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}
export default HelpLinksPage
